module.exports = __webpack_public_path__ + "img/tags_cover.fc0cef62.webp";